<template>
  <v-menu
    v-model="popup"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field :value="valueAsString" :label="label" readonly v-on="on"></v-text-field>
    </template>
    <v-date-picker
      locale="ru"
      :value="valueAsString"
      :first-day-of-week="1"
      @input="onDatePick"
    ></v-date-picker>
  </v-menu>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    value: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      popup: false,
    }
  },
  computed: {
    valueAsString() {
      return this.$moment(this.value).format('YYYY-MM-DD')
    },
  },
  methods: {
    onDatePick(value) {
      this.popup = false
      this.$emit('input', this.$moment(value))
    },
  },
}
</script>
